import { IconButton, Stack, Tooltip } from '@mui/material';
import Iconify from 'src/components/iconify';

export interface ItemActionMenuProps {
  onDelete: () => void;
  onCopy: () => void;
  deleteLabel?: string;
  copyLabel?: string;
}

/**
 * 아이템 액션 버튼 컴포넌트
 * - 복사/삭제 버튼을 아이템 우측 상단에 직접 노출
 */
function ItemActionMenu({
  onDelete,
  onCopy,
  deleteLabel = '삭제',
  copyLabel = '복사',
}: ItemActionMenuProps) {
  return (
    <Stack
      direction="column"
      spacing={0.5}
      sx={{
        position: 'absolute',
        left: -16,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
      }}
    >
      <Tooltip title={copyLabel} arrow placement="left">
        <IconButton
          type="button"
          size="small"
          onClick={onCopy}
          sx={{
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            color: 'text.secondary',
            '&:hover': {
              bgcolor: 'action.hover',
              color: 'primary.main',
              borderColor: 'primary.main',
            },
          }}
        >
          <Iconify icon="tabler:copy" width={16} />
        </IconButton>
      </Tooltip>
      <Tooltip title={deleteLabel} arrow placement="left">
        <IconButton
          type="button"
          size="small"
          onClick={onDelete}
          sx={{
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            color: 'text.secondary',
            '&:hover': {
              bgcolor: 'error.lighter',
              color: 'error.main',
              borderColor: 'error.main',
            },
          }}
        >
          <Iconify icon="eva:trash-2-fill" width={16} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}

export default ItemActionMenu;
